import { render, staticRenderFns } from "./BusinessBranchEdit.vue?vue&type=template&id=ab653b68"
import script from "./BusinessBranchEdit.vue?vue&type=script&lang=ts"
export * from "./BusinessBranchEdit.vue?vue&type=script&lang=ts"
import style0 from "./BusinessBranchEdit.vue?vue&type=style&index=0&id=ab653b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports